import { DadosBorderoDupGeral, DadosRelCtaPagar, DadosRelDiaCtaPagar, LanctoContaPag, ParamsEstDupPagar, ParamsLiqDupPagar, RetAPI, contaAPagar, contaAPagarAttributes, error99 } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'
import { DadosRelCtaPagarDetalhado } from '../../Components/GridProducts/GridRelCtaPagarDetalhado'


export const ContaAPagarService = {

    // sem uso
    /*
    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<contaAPagar[]> => {

        const resp = await Api('DupPagar/filter', 'get', { field, filter_type, filter, id })
        const contasApagar: contaAPagar[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '0') {
                resp.data.duplicatas.map((item: any) => {
                    return contasApagar.push({

                        id: item.id,
                        dt_vencimento: item.dt_vencimento,
                        id_fornecedor: item.id_fornecedor,
                        id_grupo_despesa: item.id_grupo_despesa,
                        valor: item.valor,
                        num_doc: item.num_doc,
                        serie: item.serie,
                        observacao: item.observacao,
                        dt_liquidacao: item.dt_liquidacao,
                        dt_cadastro: item.dt_cadastro,
                        id_user_insert: item.id_user_insert,
                        dt_last_update: item.dt_last_update,
                        id_user_last_update: item.id_user_last_update,
                        name_user_last_update: item.name_user_last_update,
                        name_user_insert: item.name_user_insert,
                        desc_grupo_despesa: item.desc_grupo_despesa,
                        nome_fornecedor: item.nome_fornecedor

                    })
                })

                return contasApagar
            } else {
                return []
            }
        } else {
            return []
        }

    },
    */

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('DupPagar/GetAttributes', 'get', { id })
        const attributes: contaAPagarAttributes = {
            fornecedor: [],
            grupoDespesa: [],
            subGrupoDespesa: [],
            contaAPagar: {
                id: 0,
                id_fornecedor: 0,
                id_grupo_despesa: 0,
                id_sgrupo_despesa: 0,
                id_user_insert: 0,
                id_user_last_update: 0,
                id_user_exclusao: 0,
                dt_vencimento: '',
                dt_liquidacao: '',
                dt_cadastro: '',
                dt_last_update: '',
                dh_exclusao: '',
                nome_fornecedor: '',
                desc_grupo_despesa: '',
                valor: 0,
                num_doc: '',
                serie: 0,
                observacao: '',
                name_user_insert: '',
                name_user_last_update: '',
                name_user_delete: '',
                id_bordero: 0

            }
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.fornecedores) {

                    resp.data.fornecedores.map((item: any) => {
                        attributes.fornecedor.push({
                            id: item.id,
                            description: item.nome,

                        })
                    })
                }

                if (resp.data.grupos_despesas) {
                    resp.data.grupos_despesas.map((item: any) => {
                        attributes.grupoDespesa.push({
                            id: item.id,
                            description: item.descricao,

                        })
                    })

                }

                if (resp.data.sub_grupos_despesa) {
                    resp.data.sub_grupos_despesa.map((item: any) => {
                        attributes.subGrupoDespesa?.push(
                            {
                                id: item.id,
                                description: item.descricao,

                            }
                        )
                    })
                }

                if (resp.data.duplicata) {

                    attributes.contaAPagar.id = resp.data.duplicata.id
                    attributes.contaAPagar.id_fornecedor = resp.data.duplicata.id_fornecedor
                    attributes.contaAPagar.id_grupo_despesa = resp.data.duplicata.id_grupo_despesa
                    attributes.contaAPagar.id_sgrupo_despesa = resp.data.duplicata.id_subgrupo_despesa
                    attributes.contaAPagar.id_user_insert = resp.data.duplicata.id_user_insert
                    attributes.contaAPagar.id_user_last_update = resp.data.duplicata.id_user_last_update
                    attributes.contaAPagar.id_user_exclusao = resp.data.duplicata.id_user_exclusao
                    attributes.contaAPagar.dt_vencimento = resp.data.duplicata.dt_vencimento
                    attributes.contaAPagar.dt_liquidacao = resp.data.duplicata.dt_liquidacao
                    attributes.contaAPagar.dt_cadastro = resp.data.duplicata.dt_cadastro
                    attributes.contaAPagar.dt_last_update = resp.data.duplicata.dt_last_update
                    attributes.contaAPagar.dh_exclusao = resp.data.duplicata.dh_exclusao
                    attributes.contaAPagar.nome_fornecedor = resp.data.duplicata.nome_fornecedor
                    attributes.contaAPagar.desc_grupo_despesa = resp.data.duplicata.desc_grupo_despesa
                    attributes.contaAPagar.valor = resp.data.duplicata.valor
                    attributes.contaAPagar.num_doc = resp.data.duplicata.num_doc
                    attributes.contaAPagar.serie = resp.data.duplicata.serie
                    attributes.contaAPagar.observacao = resp.data.duplicata.observacao
                    attributes.contaAPagar.name_user_insert = resp.data.duplicata.name_user_insert
                    attributes.contaAPagar.name_user_last_update = resp.data.duplicata.name_user_last_update
                    attributes.contaAPagar.name_user_delete = resp.data.duplicata.name_user_delete
                    attributes.contaAPagar.id_bordero = resp.data.duplicata.id_bordero
                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (contaApagar: contaAPagar): Promise<RetAPI> => {

        let id = ''

        if (contaApagar.id) {
            id = contaApagar.id.toString()
        }

        const resp = await Api('DupPagar/Save', 'post', {

            id_fornecedor: contaApagar.id_fornecedor,
            dt_vencimento: contaApagar.dt_vencimento,
            valor: contaApagar.valor,
            num_doc: contaApagar.num_doc,
            serie: contaApagar.serie,
            observacao: contaApagar.observacao,
            id_grupo_despesa: contaApagar.id_grupo_despesa,
            id_sgrupo_despesa: contaApagar.id_sgrupo_despesa,
            id

        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: 'Dados de conta a pagar gravados com sucesso',
                id: resp.data.duplicata.id,
                data: resp.data,
                dt_cadastro: resp.data.duplicata.dt_cadastro,
                dt_last_update: resp.data.duplicata.dt_last_update,
                name_user_insert: resp.data.duplicata.name_user_insert,
                name_user_last_update: resp.data.duplicata.name_user_last_update
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`DupPagar/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (filterDupPagar: any): Promise<RetAPI> => {

        const resp = await Api('DupPagar/Filter', 'get', {
            datai: filterDupPagar.datai,
            dataf: filterDupPagar.dataf,
            id_fornecedor: filterDupPagar.id_fornecedor,
            tipo: filterDupPagar.tipo,
            num_doc: filterDupPagar.num_doc
        })

        let dadosRel: DadosRelCtaPagar = { ctaPagar: [], qtdDup: 0, total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosRel
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                dadosRel.qtdDup = resp.data.quantidade_total
                dadosRel.total = resp.data.valor_total

                await resp.data.duplicatas.map((item: any) =>
                    dadosRel.ctaPagar.push({
                        id: item.id,
                        id_fornecedor: item.id_fornecedor,
                        id_grupo_despesa: item.id_grupo_despesa,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_vencimento: item.dt_vencimento,
                        dt_liquidacao: item.dt_liquidacao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        nome_fornecedor: item.nome_fornecedor,
                        desc_grupo_despesa: item.desc_grupo_despesa,
                        valor: item.valor,
                        num_doc: item.num_doc,
                        serie: item.serie,
                        observacao: item.observacao,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete,
                        id_bordero: item.id_bordero
                    })
                )
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosRel
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: dadosRel,
        }

    },

    FilterBordero: async (filterDupPagar?: any): Promise<RetAPI> => {

        const resp = await Api('DupPagar/Filter/Bordero', 'get', {
            datai: filterDupPagar?.datai,
            dataf: filterDupPagar?.dataf,
            id_fornecedor: filterDupPagar?.id_fornecedor,
            tipo: filterDupPagar?.tipo,
            num_doc: filterDupPagar?.num_doc,
            bordero: filterDupPagar?.bordero
        })

        const dadosBordero: DadosBorderoDupGeral = { ctaPagar: [], qtd: 0, total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosBordero
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                dadosBordero.qtd = resp.data.quantidade_total
                dadosBordero.total = resp.data.valor_total

                resp.data.duplicatas.map((item: any) => {
                    return dadosBordero.ctaPagar.push({

                        valor: item.valor,
                        id_bordero: item.id_bordero,
                        dt_liquidacao: item.dt_liquidacao,
                        obs_liquidacao: item.obs_liquidacao,
                        qtd: item.qtd
                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosBordero
            }
        }

        return {
            error: false,
            data: dadosBordero
        }

    },

    FilterExcluidas: async (filterDupPagar?: any): Promise<RetAPI> => {

        const resp = await Api('DupPagar/Filter/Excluidas', 'get', {
            datai: filterDupPagar.datai,
            dataf: filterDupPagar.dataf,
            nome_fornecedor: filterDupPagar.nome_fornecedor,
            num_doc: filterDupPagar.num_doc
        })

        let dadosExcluidas: contaAPagar[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosExcluidas
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                await resp.data.duplicatas.map((item: any) =>
                    dadosExcluidas.push({
                        id: item.id,
                        id_fornecedor: item.id_fornecedor,
                        id_grupo_despesa: item.id_grupo_despesa,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_vencimento: item.dt_vencimento,
                        dt_liquidacao: item.dt_liquidacao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        nome_fornecedor: item.nome_fornecedor,
                        desc_grupo_despesa: item.desc_grupo_despesa,
                        valor: item.valor,
                        num_doc: item.num_doc,
                        serie: item.serie,
                        observacao: item.observacao,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete,
                        id_bordero: item.id_bordero
                    })
                )
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosExcluidas
            }
        }

        return {
            error: false,
            data: dadosExcluidas
        }
    },

    Resumo: async (datai: string, dataf: string, tipoFiltro: string, idFornecedor: number): Promise<RetAPI> => {

        const resp = await Api('DupPagar/Relatorio/Resumo', 'get', { datai, dataf, tipoFiltro, idFornecedor })

        const dadosRel: DadosRelDiaCtaPagar[] = []

        let acumular = 0
        let somaTotal = 0
        let somaDup = 0

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosRel
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.resumo.map((item: any) => {

                    acumular += item.total

                    return dadosRel.push({
                        dt_vencimento: item.dt_vencimento,
                        qtd_dup: item.qtd_dup,
                        total: item.total,
                        acumulado: acumular,
                        somaDup: somaDup += item.qtd_dup,
                        somaTotal: somaTotal += item.total

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosRel
            }
        }

        return {
            error: false,
            data: dadosRel
        }

    },

    ResumoDetalhado: async (datai: string, dataf: string, tipoFiltro: string, idFornecedor: number): Promise<RetAPI> => {

        const resp = await Api('DupPagar/Relatorio/ResumoDetalhado', 'get', { datai, dataf, tipoFiltro, idFornecedor })
        let duplicatas: DadosRelCtaPagarDetalhado[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: duplicatas
                }
            }

            if (resp.data.duplicatas) {
                duplicatas = resp.data.duplicatas.map((item: any) => {
                    return {
                        dataEmissao: tipoFiltro === "A" ? item.dt_cadastro : item.dt_vencimento,
                        dataVencimento: tipoFiltro === "A" ? item.dt_vencimento : item.dt_liquidacao,
                        dataPagamento: item.dt_liquidacao,
                        observacao: item.observacao,
                        idFornecedor: item.id_fornecedor,
                        nomeFornecedor: item.nome,
                        valor: item.valor,
                        ndup: item.num_doc,
                        serie: item.serie
                    }
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: duplicatas
            }

        }

        return {
            error: false,
            data: duplicatas
        }
    },

    LiquidarDuplicatas: async (params: ParamsLiqDupPagar): Promise<RetAPI> => {

        const random = uuid()

        params.senha_usuario = base64_encode(params.senha_usuario + '-' + random)

        const resp = await Api('DupPagar/Liquidacao', 'post', params)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    EstornarLiquidacao: async (params: ParamsEstDupPagar): Promise<RetAPI> => {

        const random = uuid()

        params.senha_usuario = base64_encode(params.senha_usuario + '-' + random)

        const resp = await Api('DupPagar/Estornar', 'post', params)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || ''
                }
            }

            return {
                error: false,
                msg: ''
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    BuscarPagamentos: async (bordero: number[]): Promise<RetAPI> => {

        const resp = await Api(`DupPagar/DadosPag?bordero=${bordero}`, 'get',)
        const dados: LanctoContaPag[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dados
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.pagRecebidos.map((item: any) => {
                    return dados.push({
                        description: item.descricao,
                        id_conta: item.id_conta,
                        valor: item.valor,
                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dados
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: dados,
        }

    },


}
